import { useState } from "react";
import {
  Card,
  Typography,
  Grid,
  TextField,
  Breadcrumbs,
  Box,
  Stack,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  FormControlLabel,
  InputAdornment,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import SearchIcon from "@mui/icons-material/Search";
import CardView from "./CardView";
import ListView from "./ListView";
import PaginationComponent from "../../components/Pagination/Pagination";
import Offcanvas from "react-bootstrap/Offcanvas";

const ItemList = () => {
  const [itemsView, setItemsView] = useState("");
  const [openIssue, setOpenIssue] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();

  const { breadcrumb } = location.state || { breadcrumb: [] };

  const itemName =
    breadcrumb.length > 0 ? breadcrumb[breadcrumb.length - 1] : "Wire 3";

  const handleView = (e) => {
    setItemsView(e.target.value);
  };

  const handleOpenIssueBox = () => setOpenIssue(true);
  const handleCloseIssueBox = () => setOpenIssue(false);

  const handleCloseOptions = () => setShowOptions(false);
  const handleShowOptions = () => {
    if (isMobile) {
      setShowOptions(true);
      handleCloseIssueBox();
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "75%",
    height: "95%",
    overflow: "auto",
    bgcolor: "#F5F5F5",
    p: 4,
  };
  return (
    <>
      <Card className="shadow p-3 " style={{ marginTop: "1rem" }}>
        <Grid className="d-flex justify-content-between mb-2">
          <Typography variant="h5" fontWeight={700}>
            Item List
          </Typography>
          <img src="/images/printer.svg"></img>
        </Grid>
        <Box className="d-flex align-items-center gap-2 mb-2">
          Location :
          <Typography variant="h6" fontWeight={700}>
            {itemName}
          </Typography>
        </Box>
        <Box>
          <Breadcrumbs
            separator=">>"
            aria-label="breadcrumb"
            //   sx={{
            //     display: "flex",
            //     alignItems: "center",
            //   }}
          >
            <img src="/images/Home.svg" />
            {breadcrumb.map((crumb, index) => (
              <Typography key={index}>{crumb}</Typography>
            ))}
          </Breadcrumbs>
        </Box>
        <Grid container spacing={3} className="mx-0 my-4">
          <Grid item xs={7} sm={8} md={4} className="p-0 pe-2 mb-3 me-3 ">
            <Box border={1} borderColor="#CCCCC" borderRadius={2} p={1.4}>
              <TextField
                variant="standard"
                placeholder="Search"
                fullWidth
                style={{ border: "none" }}
                InputProps={{
                  endAdornment: <SearchIcon fontSize="small" />,
                }}
                InputLabelProps={{ shrink: true }}
                sx={{
                  "& .MuiInputBase-root::before": {
                    borderBottom: "none",
                  },
                  "& .MuiInputBase-root::after": {
                    borderBottom: "none",
                  },
                  "& .MuiInputBase-root:hover:not(.Mui-disabled)::before": {
                    borderBottom: "none",
                  },
                }}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={0}
            sm={0}
            md={3}
            className="p-0 pe-2 mb-3 me-3"
            sx={{
              display: {
                xs: "none",
                md: "block",
              },
            }}
          >
            <Stack spacing={1}>
              <TextField
                select
                fullWidth
                label="Cards"
                onChange={handleView}
                InputProps={{
                  style: {
                    borderRadius: "8px",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <img
                        src="/images/arrow-icon.svg"
                        style={{ transform: "rotate(270deg)" }}
                      />
                    </InputAdornment>
                  ),
                }}
                SelectProps={{
                  IconComponent: () => null,
                }}
              >
                <MenuItem value="Cards">Cards</MenuItem>
                <MenuItem value="Item">Item </MenuItem>
              </TextField>
            </Stack>
          </Grid>
          <Grid
            item
            xs={2}
            sm={3}
            md={0}
            className="p-0 pe-2 mb-3 me-3 "
            sx={{
              display: {
                xs: "flex",
                md: "none",
              },
            }}
          >
            {itemsView === "Item" ? (
              <>
                <img
                  src="/images/gallery-inactive.svg"
                  value="Cards"
                  onClick={() => handleView({ target: { value: "Cards" } })}
                />
                <img
                  src="/images/list.svg"
                  value="Item"
                  onClick={() => handleView({ target: { value: "Item" } })}
                />
              </>
            ) : (
              <>
                <img
                  src="/images/gallery.svg"
                  value="Cards"
                  onClick={() => handleView({ target: { value: "Cards" } })}
                />
                <img
                  src="/images/list-inactive.svg"
                  value="Item"
                  onClick={() => handleView({ target: { value: "Item" } })}
                />
              </>
            )}
          </Grid>
          <Grid
            item
            xs={false}
            sm={false}
            md={3.5}
            lg={3}
            className="p-0 pe-2 mb-3 me-3"
            sx={{
              display: {
                xs: "none",
                md: "block",
              },
            }}
          >
            <Stack spacing={1}>
              <TextField
                fullWidth
                label="Go back to location"
                InputLabelProps={{
                  shrink: false,
                  sx: {
                    textAlign: "center",
                    width: "100%",
                  },
                }}
                InputProps={{
                  readOnly: true,
                  style: {
                    borderRadius: "8px",
                  },
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src="/images/arrow-icon.svg" alt="back-arrow" />
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            </Stack>
          </Grid>
        </Grid>
        <Box>
          {itemsView === "Item" ? (
            <ListView issueBox={handleOpenIssueBox} />
          ) : (
            <CardView issueBox={handleOpenIssueBox} />
          )}
        </Box>
      </Card>
      <div className="mt-4 d-flex justify-content-between">
        <Typography>Showing 1-4 from 4 data</Typography>
        <PaginationComponent results={[]} />
      </div>

      <Modal
        open={openIssue}
        onClose={handleCloseIssueBox}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <img
            src="/images/close-icon.svg"
            onClick={handleCloseIssueBox}
            style={{
              cursor: "pointer",
              position: "absolute",
              top: "20px",
              right: "20px",
            }}
            alt="close"
          />
          <Typography
            id="modal-modal-title"
            variant="h5"
            fontWeight={700}
            component="h2"
          >
            {itemName}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <div>
              Quantity : <span style={{ fontWeight: "600" }}>300</span>
            </div>
            <div>
              Report Issue with item{" "}
              <span style={{ fontWeight: "600" }}>#193</span>
            </div>
          </Typography>
          <Card
            sx={{ mt: 3, p: 3 }}
            style={{
              boxShadow: "0px 4px 4px 0px #0000000F",
              borderRadius: "8px",
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography variant="h6" fontWeight={700} component="h3">
                  Issue
                </Typography>
                <TextField
                  label="Write the issues"
                  multiline
                  rows={4}
                  fullWidth
                  variant="outlined"
                  sx={{ mt: 2 }}
                />
                <TextField
                  label="Quantity"
                  type="number"
                  fullWidth
                  variant="outlined"
                  sx={{ mt: 2 }}
                />
                <Typography sx={{ mt: 2 }}>Priority:</Typography>
                <RadioGroup row>
                  <FormControlLabel
                    value="High"
                    control={<Radio color="error" />}
                    label="High"
                  />
                  <FormControlLabel
                    value="Med"
                    control={<Radio />}
                    label="Med"
                  />
                  <FormControlLabel
                    value="Low"
                    control={<Radio />}
                    label="Low"
                  />
                </RadioGroup>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography variant="h6" fontWeight={700} component="h3">
                  Image
                </Typography>
                <Box
                  sx={{
                    mt: 2,
                    border: "1px dashed grey",
                    padding: 2,
                    textAlign: "center",
                    height: "200px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{ display: "none" }}
                    id="image-upload"
                  />
                  <label htmlFor="image-upload">
                    <img
                      src="/images/upload-icon.png"
                      style={{ cursor: "pointer" }}
                      onClick={handleShowOptions}
                    />
                  </label>
                </Box>
              </Grid>
            </Grid>
          </Card>
          <Box sx={{ mt: 3, textAlign: "center" }}>
            <ButtonTheme
              variant="contained"
              color="DarkRed"
              className="py-2 px-4"
              style={{ borderRadius: "40px" }}
              onClick={handleCloseIssueBox}
            >
              Confirm Issue
            </ButtonTheme>
          </Box>
        </Box>
      </Modal>
      {isMobile && (
        <Offcanvas
          show={showOptions}
          onHide={handleCloseOptions}
          placement="bottom"
        >
          <Offcanvas.Body>
            <div className="d-flex gap-4 ms-3 mt-4">
              <div className="d-flex flex-column align-items-center gap-3">
                <img src="/images/camera-upload.svg" alt="camera-icon" />
                <p className="m-0">Camera</p>
              </div>
              <input
                type="file"
                accept="image/*"
                capture="environment"
                style={{ display: "none" }}
                id="image-upload"
              />
              <label htmlFor="image-upload">
                <div className="d-flex flex-column align-items-center gap-3">
                  <img src="/images/gallery-upload.svg" alt="gallery-icon" />
                  <p className="m-0">Gallery</p>
                </div>
              </label>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
    </>
  );
};

export default ItemList;
